import { createElement } from 'react';
import { a as _objectSpread2 } from './_rollupPluginBabelHelpers-3b7bd988.js';
import Icon from './Icon/Icon.js';
import { icons } from './Icon/icons.js';
import RcNotification from 'rc-notification';
import NotificationDetails from './Notification/NotificationDetails.js';

let Kind = /*#__PURE__*/function (Kind) {
  Kind["SUCCESS"] = "success";
  Kind["INFO"] = "info";
  Kind["WARNING"] = "warning";
  Kind["ERROR"] = "error";
  return Kind;
}({});

const notificationInstance = {};
let defaultDuration = 4.5;
let defaultTop = 24;
let defaultBottom = 24;
let defaultPlacement = 'topRight';
let defaultGetContainer;
function setNotificationConfig(options) {
  const {
    duration,
    placement,
    bottom,
    top,
    getContainer
  } = options;
  if (duration !== undefined) {
    defaultDuration = duration;
  }
  if (placement !== undefined) {
    defaultPlacement = placement;
  }
  if (bottom !== undefined) {
    defaultBottom = bottom;
  }
  if (top !== undefined) {
    defaultTop = top;
  }
  if (getContainer !== undefined) {
    defaultGetContainer = getContainer;
  }
}
function getPlacementStyle(placement, theme) {
  let style;
  switch (placement) {
    case 'topLeft':
      style = {
        left: theme.spacing.md,
        top: defaultTop,
        bottom: 'auto'
      };
      break;
    case 'topRight':
      style = {
        right: theme.spacing.md,
        top: defaultTop,
        bottom: 'auto'
      };
      break;
    case 'bottomLeft':
      style = {
        left: theme.spacing.md,
        top: 'auto',
        bottom: defaultBottom
      };
      break;
    default:
      style = {
        right: theme.spacing.md,
        top: 'auto',
        bottom: defaultBottom
      };
      break;
  }
  return style;
}
function getNotificationInstance(placement, theme, callback) {
  const cacheKey = `${placement}`;
  if (notificationInstance[cacheKey]) {
    callback(notificationInstance[cacheKey]);
    return;
  }
  RcNotification.newInstance({
    prefixCls: 'notification',
    style: getPlacementStyle(placement, theme),
    getContainer: defaultGetContainer,
    closeIcon: /*#__PURE__*/createElement(Icon, {
      glyph: icons.CLOSE,
      size: 24
    })
  }, notification => {
    notificationInstance[cacheKey] = notification;
    callback(notification);
  });
}
function notice(args) {
  const duration = args.duration === undefined ? defaultDuration : args.duration;
  let additionalClass = '';
  switch (args.type) {
    case Kind.SUCCESS:
      additionalClass = 'success';
      break;
    case Kind.INFO:
      additionalClass = 'info';
      break;
    case Kind.WARNING:
      additionalClass = 'warning';
      break;
    case Kind.ERROR:
      additionalClass = 'error';
      break;
    default:
      additionalClass = '';
  }
  getNotificationInstance(args.placement || defaultPlacement, args.theme, notification => {
    notification.notice({
      duration,
      content: /*#__PURE__*/createElement(NotificationDetails, {
        showIcon: !!args.type,
        messageType: args.type,
        description: args.description,
        title: args.message,
        theme: args.theme
      }),
      closable: true,
      onClose: args.onClose,
      key: args.key,
      style: args.style || {},
      className: `${args.className} ${additionalClass}`
    });
  });
}
const api = {
  open: notice,
  close(key) {
    Object.keys(notificationInstance).forEach(cacheKey => notificationInstance[cacheKey].removeNotice(key));
  },
  config: setNotificationConfig,
  destroy() {
    Object.keys(notificationInstance).forEach(cacheKey => {
      notificationInstance[cacheKey].destroy();
      delete notificationInstance[cacheKey];
    });
  }
};
[Kind.SUCCESS, Kind.INFO, Kind.WARNING, Kind.ERROR].forEach(type => {
  api[type] = args => api.open(_objectSpread2(_objectSpread2({}, args), {}, {
    type
  }));
});
api.warn = api.warning;

export { Kind as K, api as a };
